const curYear = new Date().getFullYear();

export const allBeforeCurrentYear=(years:number[])=>{
    return years.every(y=>y<curYear);
}

export const getRidOfOutdatedYears=(years:number[])=>{
    return years.filter(y=>y>=curYear);
}

export const beforeCurrentYear=(y:number)=>{
    return y<curYear;
}